import styled from '@emotion/styled';

import BG from '../../images/footer.png';

export const FooterBG = styled.footer`
  background: url(${BG});
  background-size: contain;
  background-repeat: repeat no-repeat;
  background-position: 0 100%;
`;
